module.exports = __webpack_public_path__ + "static/icons/icon-snow-alert--white-1fce21bd333a165f328cbde82fb8f751.svg";